import { createAction, props } from '@ngrx/store';
import {
  CameraWithMediaDto,
  VideoStream,
  VideoStreamUrlRequest
} from "../../../core/store/models/camera-with-media.model";

// traffic camera actions
export const getTrafficStream = createAction('[COP/Cameras] Get Traffic Stream', props<{ cameraId: string; width: string; height: string, coding: string, container: string }>());
export const loadTrafficStream = createAction('[COP/Cameras] Load Traffic Stream', props<{ streamUrl: string }>());
export const getTrafficCameraImage = createAction('[COP/Cameras] Get Traffic Camera Image', props<{ cameraId: string }>());
export const loadTrafficCameraImage = createAction('[COP/Cameras] Load Traffic Camera Image', props<{ imageUrl: string }>());

// popout window actions
export const showVideoWindow = createAction('[COP/Cameras] Show Video Window', props<{ videoStream: VideoStream }>());
export const hideVideoWindow = createAction('[COP/Cameras] Hide Video Window', props<{ videoStream: VideoStream }>());
export const refreshVideoStream = createAction('[COP/Cameras] Refresh Video Stream', props<{ videoStream: VideoStream }>());
export const refreshVideoStreamComplete = createAction('[COP/Cameras] Refresh Video Stream Complete', props<{ videoStream: VideoStream }>());

// openeye actions
export const getOpenEyeCameraStreamUrl = createAction(
    '[COP/Cameras] Get OpenEye Camera Stream Url',
    props<{ companyId: string; deviceId: string; cameraId: string; streamName: string; pipelineDefinitionUId: string }>()
);
export const loadOpenEyeCameraStreamUrl = createAction('[COP/Cameras] Load OpenEye Camera Stream Url', props<{ cameraStreamUrl: string }>());
export const getOpenEyeCameraImageUrl = createAction(
    '[COP/Cameras] Get OpenEye Camera Image Url',
    props<{ companyId: string; deviceId: string; cameraId: string; streamName: string; pipelineDefinitionUId: string }>()
);
export const loadOpenEyeCameraImageUrl = createAction('[COP/Cameras] Load OpenEye Camera Image Url', props<{ cameraImageUrl: string }>());

// Agent VMS camera actions
export const getVmsCameraMedia = createAction(
    '[COP/Cameras] Get VMS Camera Media',
    props<{ integrationKey: string; cameraId: string; mediaWidths?: number[] }>()
);
export const loadVmsCameraMedia = createAction(
    '[COP/Cameras] Load VMS Camera Media',
    props<{ integrationKey: string; cameras?: CameraWithMediaDto[] }>()
);

export const getVideoStreamUrl = createAction('[COP/Cameras] Get Video Stream Url', props<{ request: VideoStreamUrlRequest }>());
export const loadVideoStreamUrl = createAction('[COP/Cameras] Load Video Stream Url', props<{ videoStreamUrl: string }>());

export const getLiveViewToken = createAction('[COP/Cameras] Get LiveView Token', props<{ pipelineDefinitionUId: string }>());
export const loadLiveViewToken = createAction('[COP/Cameras] Load LiveView Token', props<{ liveViewToken: string }>());
